export enum Condition {
  'whenSignIn',
  'whenSignOut',
  'whenGetCurrentSession',
  'whenCompleteNewPassword',
  'whenForgotPassword',
  'whenChangePassword',
  'whenChangePasswordFirst',
  'whenForgotPasswordSubmit',
  'whenSignUp',
  'whenUpdateAttributes',
  'whenAuthenticateUser',
}
